// 返回头部，以及二维码
<template lang="pug">
.fixed-bar-wrap(v-if="isShow")
  a.icon(v-for="item in list" v-if="item.url" :style="item.background", :href="item.url", target="_blank")
    span(@click="handleBury(item.channelName)") {{item.name}}
</template>

<script>
export default {
  name: 'back-top-ercode',
  data() {
    const IMUrl = this.$store.getters.IMUrl
    return {
      list: [
        {
          url: IMUrl.twitter,
          name: 'Loklok_app Twitter',
          channelName: 'twitter',
          background: 'background-position: center top'
        },
        {
          url: IMUrl.youtube,
          name: 'Loklok youtube',
          channelName: 'youtube',
          background: 'background-position: center -32px'
        },
        {
          url: IMUrl.facebook,
          name: 'Loklok Fanpage facebook',
          channelName: 'facebook',
          background: 'background-position: center -64px'
        },
        {
          url: IMUrl.ins,
          name: 'Loklok app Instagram',
          channelName: 'instagram',
          background: 'background-position: center -96px'
        },
        {
          url: IMUrl.whatsapp,
          name: 'Loklok app whatsapp',
          channelName: 'whatsapp',
          background: 'background-position: center -128px'
        },
        {
          url: IMUrl.telegram,
          name: 'Loklok app telegram',
          channelName: 'telegram',
          background: 'background-position: center -160px'
        }
      ]
    }
  },
  props: {},
  computed: {
    isShow() {
      return this.$store.getters.otherIMUrl.filter((item) => item.value).length > 0
    }
  },
  methods: {
    handleBackTop() {
      window.scrollTo(0, 0)
    },
    handleBury(name) {
      this.$LokBury.handleMD(
        {
          buryEventId: 'UM_Event_HeadNaviClick',
          buryParams: {
            UM_Key_ButtonID: name
          }
        },
        'click'
      )
    }
  }
}
</script>

<style lang="sass" scoped>
.fixed-bar-wrap
  position: fixed
  width: 72px
  // height: 228px
  right: 0px
  bottom: 126px
  background: #333333
  border-radius: 16px 0px 0px 16px
  padding: 20px
  display: flex
  flex-direction: column
  z-index:10
  // justify-content: space-between
  .icon
    width: 32px
    height: 32px
    background-image: url(https://img.loklok.video/fe/9cf36e0f-50f5-438d-99f1-ff23decb7c87/im2.png)
    background-size: 32px auto
    cursor: pointer
    margin-top: 28px
    &:first-child
     margin-top: 0px
    span
      opacity: 0
</style>
